import clsx from 'clsx';
import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const HeadLine = ({ headLine, hasHat, tag }) => (
  <Text tag={tag} field={headLine} className={clsx('h1 hero-title', hasHat && 'has-hat')} />
);

export default HeadLine;
